import { computed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const DeleteProfileModal = function ({ showSignal, deleteProfileItemSignal, newProfileNameSignal, handleSubmit }) {

    const deleteProfileConfirmNameSignal = useSignal('')
    const disableDeleteSubmitComputed = computed(() => {
        if (deleteProfileItemSignal.value.name) {
            return deleteProfileItemSignal.value.name != deleteProfileConfirmNameSignal.value
        }
    })

    const handleCloseModal = () => {
        showSignal.value = false
    }

    return (
        <Modal show={showSignal.value} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Profile {deleteProfileItemSignal.value.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Deleting a profile is a permanent action that cannot be reversed. Once a profile is deleted, you will no longer be able to view the associated services or installations. Any installation packages using this profile will no longer be accessible. Additionally, you will no longer be able to track version differences between the profile and services that have previously leveraged this profile.</p>
                <p>If you are sure you want to delete this profile, please enter the name of the profile below and select &quot;Delete&quot; to complete the process.</p>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Profile Name: {deleteProfileItemSignal.value.name}</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => deleteProfileConfirmNameSignal.value = e.target.value}
                            autoFocus
                            defaultValue={newProfileNameSignal.value}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseModal}>
                    Cancel
                </Button>
                <Button disabled={disableDeleteSubmitComputed.value} variant="danger" onClick={handleSubmit}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default DeleteProfileModal